import {Fragment} from 'react';

import {LicenseService as Service} from './LicenseService';

import {useToolbar} from '../../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../../shared/hooks/DataTable';
import {useTranslation} from '../../../../shared/language';

export const List = () => {

  const {t} = useTranslation();
  const header = t('menu.license');
  const dataKey = 'id';

  const {render: renderDataTable, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'companyName', header: t('system.companyName'), matchMode: 'contains', style: {minWidth: '250px'}},
      {field: 'licenseKey', header: t('system.serial'), matchMode: 'contains', style: {minWidth: '250px'}},
      {field: 'invoiceQuantity', header: t('system.licenseQuantity'), matchMode: 'contains', style: {minWidth: '100px'}},
      {field: 'productName', header: t('system.product'), matchMode: 'contains', style: {minWidth: '150px'}},
      {field: 'issueDate', header: t('system.issueDate'), matchMode: 'contains', style: {minWidth: '150px'}, dataType: 'date'},
      {field: 'licenseStartDate', header: t('system.startDate'), matchMode: 'contains', style: {minWidth: '150px'}, dataType: 'date'},
      {field: 'licenseEndDate', header: t('system.expiryDate'), matchMode: 'contains', style: {minWidth: '150px'}, dataType: 'date'},
      {field: 'numberDevice', header: t('catalog.deviceName'), matchMode: 'contains', style: {width: '120px'}},
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {renderToolbar} = useToolbar({
    dataKey,
    reloadLazyData,
    selectedItems
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
    </Fragment>
  )
}
